<template>
  <q-page class="register" :class="{'bg-white': !$isDesktop}">
    <div class="row justify-center items-center" :class="$isDesktop ? 'q-pa-xl' : 'q-pa-md'">
      <q-card v-if="$isDesktop" class="col-6">
        <common-form :action="$route('auth.store')">
          <q-card-section class="q-pa-lg">
            <register-form />
          </q-card-section>
          <q-separator />
          <q-card-actions align="between" class="q-py-md q-px-lg">
            <common-link label="Ik heb al een account" :href="$route('auth.login')" />
            <flat-button v-if="ssoAvailable"
                         outline
                         class="q-mb-sm"
                         label="Registreer met Azure"
                         :href="$route('auth.login.withAzure')" />
            <accent-button type="submit" label="Registreer"/>
          </q-card-actions>
        </common-form>
      </q-card>
      <div v-else class="col-xs-12 col-sm-10 q-mt-lg">
        <common-form :action="$route('auth.store')">
          <register-form />
          <q-separator />
          <div class="row justify-between q-mt-md">
            <flat-button outline label="Ik heb al een account" @click="$goto('auth.login')" />
            <flat-button v-if="ssoAvailable"
                         outline
                         class="q-mb-sm"
                         label="Registreer met Azure"
                         :href="$route('auth.login.withAzure')" />
            <accent-button type="submit" label="Registreer"/>
          </div>
        </common-form>
      </div>
    </div>
  </q-page>
</template>

<script>
import RegisterForm from './form/Register'

export default {
  components: {
    RegisterForm
  },
  props: {
    ssoAvailable: {
      type: Boolean,
    },
  },
}
</script>
